import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import { ReactComponent as ArrowDownIcon } from '../assets/arrow-down.svg';
import { ReactComponent as BackIcon } from '../assets/Back.svg';
import '../scss/components/suggestionsPage.scss';

const SuggestionsPage = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isTypeOpen, setIsTypeOpen] = useState(false);
    const [error, setError] = useState('');

    // Максимальная длина текста в textarea
    const MAX_TEXT_LENGTH = 1000;

    const suggestionTypes = [
        "Отлично",
        "Хорошо",
        "Нормально",
        "Плохо",
        "Ужасно"
    ];

    const [formData, setFormData] = useState({
        type: "",
        description: "",
        currentSolution: "",
        problemDescription: "",
        expectedResult: "",
        additionalInfo: ""
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Проверка на максимальную длину
        if (value.length <= MAX_TEXT_LENGTH) {
            setFormData(prev => ({ ...prev, [name]: value }));

            // Автоматическое изменение высоты textarea
            if (e.target.tagName === 'TEXTAREA') {
                adjustTextareaHeight(e);
            }
        }
    };

    const adjustTextareaHeight = (e) => {
        const textarea = e.target;
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
    };

    const handleSubmit = async () => {
        if (!formData.type || !formData.description) {
            setError('Пожалуйста, заполните обязательные поля: тип предложения и описание');
            return;
        }

        setIsLoading(true);
        setError('');

        try {
            const initData = window.Telegram.WebApp.initData;
            await axios.post(`${config.API_BASE_URL}/suggestions/save`, {
                initData,
                suggestion: formData
            });

            setIsSubmitted(true);
            setTimeout(() => {
                navigate(-1);
            }, 2000);
        } catch (error) {
            console.error('Ошибка при отправке предложения:', error);
            setError('Произошла ошибка при отправке. Пожалуйста, попробуйте позже.');
        } finally {
            setIsLoading(false);
        }
    };

    const goBack = () => {
        navigate(-1);
    };

    // Функция для отображения счетчика символов
    const getCharacterCount = (fieldName) => {
        return `${formData[fieldName].length}/${MAX_TEXT_LENGTH}`;
    };

    return (
        <div className="suggestions-page">
            <div className="suggestions-header">
                <button className="back-button" onClick={goBack}>
                    <BackIcon />
                </button>
                <h1>Предложения по улучшению</h1>
            </div>

            {isSubmitted ? (
                <div className="success-message">
                    <p>Ваше предложение успешно отправлено! Спасибо за ваш вклад.</p>
                </div>
            ) : (
                <div className="suggestions-form">
                    {error && (
                        <div className="error-message">
                            <p>{error}</p>
                        </div>
                    )}

                    <div className="form-section">
                        <p className="field-description">1. Оцените удобство навигации в приложении:</p>
                        <div className="dropdown">
                            <div className="dropdown-header" onClick={() => setIsTypeOpen(!isTypeOpen)}>
                                {formData.type || "Оцените ваш опыт использования"}
                                <ArrowDownIcon className={`arrow-icon ${isTypeOpen ? 'up' : ''}`} />
                            </div>
                            {isTypeOpen && (
                                <ul className="dropdown-list">
                                    {suggestionTypes.map((type) => (
                                        <li key={type} onClick={() => {
                                            setFormData({ ...formData, type });
                                            setIsTypeOpen(false);
                                        }}>
                                            {type}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>

                    <div className="form-section">
                        <p className="field-description">2. Есть ли у вас предложения по улучшению интерфейса приложения?</p>
                        <div className="input-wrapper">
                            <textarea
                                className="textarea-field"
                                name="description"
                                value={formData.description}
                                onChange={handleInputChange}
                                onInput={adjustTextareaHeight}
                                placeholder="Опишите ваше предложение..."
                                maxLength={MAX_TEXT_LENGTH}
                            />
                        </div>
                        <div className="char-counter">{getCharacterCount("description")}</div>
                    </div>

                    <h3 className="section-title">Пожелания и предложения</h3>

                    <div className="form-section">
                        <p className="field-description">1. Какие новые функции вы хотели бы видеть в приложении?</p>
                        <div className="input-wrapper">
                            <textarea
                                className="textarea-field"
                                name="currentSolution"
                                value={formData.currentSolution}
                                onChange={handleInputChange}
                                onInput={adjustTextareaHeight}
                                placeholder="Ваше описание ..."
                                maxLength={MAX_TEXT_LENGTH}
                            />
                        </div>
                        <div className="char-counter">{getCharacterCount("currentSolution")}</div>
                    </div>

                    <div className="form-section">
                        <p className="field-description">2. Какие существующие функции следует улучшить или изменить?</p>
                        <div className="input-wrapper">
                            <textarea
                                className="textarea-field"
                                name="problemDescription"
                                value={formData.problemDescription}
                                onChange={handleInputChange}
                                onInput={adjustTextareaHeight}
                                placeholder="Ваше описание ..."
                                maxLength={MAX_TEXT_LENGTH}
                            />
                        </div>
                        <div className="char-counter">{getCharacterCount("problemDescription")}</div>
                    </div>

                    <div className="form-section">
                        <p className="field-description">3. Есть ли какие-либо проблемы или баги, с которыми вы столкнулись?</p>
                        <div className="input-wrapper">
                            <textarea
                                className="textarea-field"
                                name="expectedResult"
                                value={formData.expectedResult}
                                onChange={handleInputChange}
                                onInput={adjustTextareaHeight}
                                placeholder="Ваше описание ..."
                                maxLength={MAX_TEXT_LENGTH}
                            />
                        </div>
                        <div className="char-counter">{getCharacterCount("expectedResult")}</div>
                    </div>

                    <div className="form-section">
                        <p className="field-description">4. Есть ли что-то, что вы хотели бы добавить ещё?</p>
                        <div className="input-wrapper">
                            <textarea
                                className="textarea-field"
                                name="additionalInfo"
                                value={formData.additionalInfo}
                                onChange={handleInputChange}
                                onInput={adjustTextareaHeight}
                                placeholder="Ваше описание ..."
                                maxLength={MAX_TEXT_LENGTH}
                            />
                        </div>
                        <div className="char-counter">{getCharacterCount("additionalInfo")}</div>
                    </div>

                    <button
                        className={`submit-button ${isLoading ? 'loading' : ''}`}
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Отправка...' : 'Отправить предложение'}
                    </button>
                </div>
            )}
        </div>
    );
};

export default SuggestionsPage; 